module.exports = __webpack_public_path__ + "img/arrow_down.d6ea77ce.svg";